/* eslint-disable no-param-reassign */
/**
 * Created by zad on 17/10/18.
 */
import Immutable from 'immutable';
import normalize from '../../utils/normalize';
import { Notes, NoteHistory } from '../../constants/actionTypes';

const initialState = {
  entities: {},
  topNoteId: null,
  status: Notes.NOTES_INIT,
};

export default function (state = Immutable.fromJS(initialState), action) {
  switch (action.type) {
    // get文章
    case Notes.GET_NOTES:
      state = state.set('status', Notes.GET_NOTES);
      return state;
    case Notes.GET_NOTES_SUCCESS: {
      const { data, isCache, nbId, page, count } = action;
      if (!isCache) {
        const { entities } = normalize(data);
        // 将获取到的文章，merge到已有的store中
        const newEntities = state.get('entities').mergeDeep(Immutable.fromJS(entities));
        state = state.set('entities', newEntities);
        
        // data只有在未缓存的时候才会传进来
        data.forEach((item) => {
          if (item.is_top) {
            state = state.set('topNoteId', item.id);
          }
        });
        
        // 更新文集中的文章序列
        if (nbId && page && count) {
          // 获取当前文集的文章序列
          const currentNotes = state.getIn(['notebooksState', nbId, 'notes'], Immutable.List());
          
          // 创建新的序列
          let newSeq = currentNotes;
          
          // 如果是第一页，直接使用新数据
          if (page === 1) {
            newSeq = Immutable.List(data.map(item => item.id));
          } else {
            // 如果不是第一页，将新数据追加到现有数据后面
            data.forEach((item) => {
              newSeq = newSeq.push(item.id);
            });
          }
          
          // 更新文集状态
          state = state.setIn(['notebooksState', nbId, 'notes'], newSeq);
        }
      }
      state = state.set('status', Notes.GET_NOTES_SUCCESS);
      return state;
    }
    case Notes.GET_NOTES_FAIL:
      state = state.set('status', Notes.GET_NOTES_FAIL);
      return state;
    // sort文章
    case Notes.SORT_NOTES: {
      state = state.set('status', Notes.SORT_NOTES);
      return state;
    }
    case Notes.SORT_NOTES_SUCCESS: {
      state = state.set('status', Notes.SORT_NOTES_SUCCESS);
      return state;
    }
    case Notes.SORT_NOTES_FAIL: {
      state = state.set('status', Notes.SORT_NOTES_FAIL);
      return state;
    }
    // 创建文章
    case Notes.NEW_NOTE: {
      state = state.set('status', Notes.NEW_NOTE);
      return state;
    }
    case Notes.NEW_NOTE_SUCCESS: {
      const { data, nbId, atBottom, hasTop } = action;
      // 新建的文章需要添加到entities中
      state = state.setIn(['entities', data.id.toString()], Immutable.fromJS(data).merge(
         // 默认新文章可以转载
        {reprintable: true,}
      ));
      // 如果是添加到顶部，需要判断是否已经有置顶文章
      if (!atBottom && !hasTop) {
        // 添加到文集的第一位
        const nbPath = ['notebooksState', nbId.toString(), 'notes'];
        const seq = state.getIn(nbPath, Immutable.fromJS([]));
        state = state.setIn(nbPath, seq.unshift(data.id));
      } else if (!atBottom && hasTop) {
        // 如果有置顶文章，添加到置顶文章后面
        const nbPath = ['notebooksState', nbId.toString(), 'notes'];
        const seq = state.getIn(nbPath, Immutable.fromJS([]));
        state = state.setIn(nbPath, seq.insert(1, data.id));
      } else {
        // 添加到文集的末尾
        const nbPath = ['notebooksState', nbId.toString(), 'notes'];
        const seq = state.getIn(nbPath, Immutable.fromJS([]));
        state = state.setIn(nbPath, seq.push(data.id));
      }
      state = state.set('status', Notes.NEW_NOTE_SUCCESS);
      return state;
    }
    case Notes.NEW_NOTE_FAIL: {
      state = state.set('status', Notes.NEW_NOTE_FAIL);
      return state;
    }
    // 发布文章
    case Notes.PUBLISH_NOTE: {
      const { noteId, data } = action;
      state = state.setIn(['entities', noteId.toString(), 'status'], Notes.PUBLISH_NOTE);
      return state;
    }
    case Notes.PUBLISH_NOTE_SUCCESS: {
      const { noteId, data } = action;
      state = state.setIn(['entities', noteId.toString(), 'shared'], true);
      state = state.setIn(['entities', noteId.toString(), 'schedule_publish_at'], null);
      state = state.setIn(['entities', noteId.toString(), 'last_compiled_at'], data.last_compiled_at);
      state = state.setIn(['entities', noteId.toString(), 'status'], Notes.PUBLISH_NOTE_SUCCESS);
      return state;
    }
    case Notes.PUBLISH_NOTE_FAIL: {
      const { noteId, data } = action;
      state = state.setIn(['entities', noteId.toString(), 'status'], Notes.PUBLISH_NOTE_FAIL);
      return state;
    }
    // 私密化文章
    case Notes.PRIVATE_NOTE: {
      const { noteId, data } = action;
      state = state.setIn(['entities', noteId.toString(), 'status'], Notes.PRIVATE_NOTE);
      return state;
    }
    case Notes.PRIVATE_NOTE_SUCCESS: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'shared'], false);
      state = state.setIn(['entities', noteId.toString(), 'status'], Notes.PRIVATE_NOTE_SUCCESS);
      return state;
    }
    case Notes.PRIVATE_NOTE_FAIL: {
      const { noteId, data } = action;
      state = state.setIn(['entities', noteId.toString(), 'status'], Notes.PRIVATE_NOTE_FAIL);
      return state;
    }
    // 软性删除文章
    case Notes.DEL_NOTE_SOFT: {
      const { nbId, noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'status'], Notes.DEL_NOTE_SOFT);
      return state;
    }
    case Notes.DEL_NOTE_SOFT_SUCCESS: {
      const { data, noteId, nbId } = action;
      // 删除文章需要在entities中删除
      state = state.deleteIn(['entities', noteId.toString()]);
      // 同时需要在文集的seq中删除
      const notesPath = ['notebooksState', nbId.toString(), 'notes'];
      let notes = state.getIn(notesPath);
      const index = notes.findIndex(item => item === +noteId);
      notes = notes.delete(index);
      state = state.setIn(notesPath, notes);
      return state;
    }
    case Notes.DEL_NOTE_SOFT_FAIL: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'status'], Notes.DEL_NOTE_SOFT_FAIL);
      return state;
    }
    // 更新文章内容
    case Notes.UPDATE_NOTE: {
      const { noteId, content, title } = action;
      // 不管服务端，直接更新本地的数据，并autosave_control + 1
      state = state.setIn(['entities', noteId.toString(), 'title'], title);
      const autosaveControl = state.getIn(['entities', noteId.toString(), 'autosave_control']);
      state = state.setIn(['entities', noteId.toString(), 'autosave_control'], autosaveControl + 1);
      return state;
    }
    case Notes.UPDATE_NOTE_SUCCESS: {
      const { noteId, data } = action;
      state = state.setIn(['entities', noteId, 'content_updated_at'], data.content_updated_at);
      state = state.setIn(['entities', noteId, 'status'], Notes.UPDATE_NOTE_SUCCESS);
      return state;
    }
    // 恢复版本,更新标题
    case NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_SUCCESS: {
      const { revertData: { title, content }, nbId, noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'title'], title);
      return state;
    }
    // 移动文章成功，需要修改文章所属的notebook_id
    case Notes.MOVE_NOTE_SUCCESS: {
      const { data, nbId, newNbId, noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'notebook_id'], newNbId);
      return state;
    }
    // 发表付费文章成功
    case Notes.PUBLISH_PAID_NOTE_SUCCESS: {
      const { data, noteId, nbId } = action;
      state = state.setIn(['entities', noteId.toString(), 'paid'], true);
      state = state.setIn(['entities', noteId.toString(), 'shared'], true);
      state = state.setIn(['entities', noteId.toString(), 'schedule_publish_at'], null);
      state = state.setIn(['entities', noteId.toString(), 'last_compiled_at'], data.last_compiled_at);
      return state;
    }
    // 置顶文章
    case Notes.POST_SET_NOTE_TOP_SUCCESS: {
      const { noteId } = action;
      const topNoteId = state.get('topNoteId');
      if (topNoteId) {
        state = state.setIn(['entities', topNoteId.toString(), 'is_top'], false);
      }
      state = state.setIn(['entities', noteId.toString(), 'is_top'], true);
      state = state.set('topNoteId', noteId);
      return state;
    }
    // 取消置顶文章
    case Notes.POST_UNSET_NOTE_TOP_SUCCESS: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'is_top'], false);
      state = state.set('topNoteId', null);
      return state;
    }
    // 设置文章转载状态
    case Notes.SET_NOTE_REPRINTABLE_SUCCESS: {
      const { noteId } = action;
      state = state.updateIn(['entities', noteId.toString(), 'reprintable'], v => !v);
      return state;
    }
    // 设置定时发文
    case Notes.SET_NOTE_PUBLISH_TIME_SUCCESS: {
      const { noteId, publishTime } = action;
      state = state.setIn(['entities', noteId.toString(), 'schedule_publish_at'], publishTime);
      return state;
    }
    default:
      return state;
  }
}

export const getState = state => state.Notes;



// WEBPACK FOOTER //
// ./src/reducers/Notes/NotesReducer.js